module.exports = __webpack_public_path__ + "static/iot-icon_1-ca8b98d4088393895ea57d4c25679c03.svg";